document.addEventListener("DOMContentLoaded", () => {
  // -------------------------
  // CONFIGURATION
  // -------------------------

  // [ISSUE] gwpVariantId comes from Liquid as a STRING, but cart.js returns
  // variant_id as a NUMBER. The strict === comparison later in this file
  // never matched because of this, so the targeted removal path silently
  // never ran and everything fell through to the unconditional catch-all.
  // [FIX] Coerce both to Number so comparisons actually work.
  // --- BEFORE ---
  // const GWP_VARIANT_ID = window.ShopifyThemeSettings.gwpVariantId; // Replace with your actual GWP variant ID
  // const THRESHOLD = window.ShopifyThemeSettings.gwpThreshold; // Cart threshold in dollars
  // --- AFTER ---
  const GWP_VARIANT_ID = Number(window.ShopifyThemeSettings.gwpVariantId);
  const THRESHOLD = Number(window.ShopifyThemeSettings.gwpThreshold);

  // "discount" mode adds the full-price GWP product and relies on a Shopify
  // discount to make it free at checkout. Unlike "swap" mode, it should stay
  // in the cart even if the customer falls below threshold — removal is left
  // to the customer via the cart's own remove control.
  const GWP_MODE = window.ShopifyThemeSettings.gwpMode || 'swap';

  let gwpLock = false; // Prevent multiple simultaneous fetch/add attempts

  // [ISSUE] There was no way to tell "a cart-update event fired because a
  // real customer action happened" apart from "a cart-update event fired
  // because OUR OWN updateCart() call just completed and the theme
  // rebroadcast it." That echo re-triggered enforceGwpRules, which wrote
  // to the cart again, which triggered the event again — an infinite loop
  // that hammered /cart/update.js until Shopify returned 429.
  // [FIX] New flag, set right before any cart-mutating fetch, checked by
  // the event handler to swallow that one echo instead of acting on it.
  let suppressNextEvent = false;

  console.log('[GWP] GWP Variant ID:', GWP_VARIANT_ID);
  console.log('[GWP] Cart Threshold:', THRESHOLD);
  

  // -------------------------
  // FETCH CURRENT CART
  // -------------------------
  async function getCart() {
    try {
      const res = await fetch('/cart.js');
      // [ISSUE] No status check — a 429/5xx response was still handed to
      // res.json(), which could throw an unhelpful parse error instead of
      // a clear "the request failed" signal.
      // [FIX] Fail fast on non-OK responses.
      // --- BEFORE ---
      // const data = await res.json();
      // --- AFTER ---
      if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
      const data = await res.json();
      console.log('[GWP] Fetched cart:', data);
      return data;
    } catch (err) {
      console.error('[GWP] Error fetching cart:', err);
      return null;
    }
  }

  // -------------------------
  // UPDATE CART QUANTITIES
  // -------------------------
  async function updateCart(updates) {
    try {
      console.log('[GWP] Updating cart with:', updates);
      // [FIX] Mark this as a self-triggered write before firing it, so the
      // resulting cart-update event (if the theme rebroadcasts one) gets
      // ignored instead of re-running enforcement. This is the core fix
      // for the request-storm/429 issue.
      suppressNextEvent = true;
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      // [FIX] Same res.ok guard as getCart().
      if (!res.ok) throw new Error(`Cart update failed: ${res.status}`);
      const data = await res.json();
      console.log('[GWP] Cart updated:', data);
      return data;
    } catch (err) {
      console.error('[GWP] Error updating cart:', err);
      // [FIX] If the write never actually went through, there's nothing
      // to suppress — reset the flag so a later legitimate event isn't
      // swallowed by mistake.
      suppressNextEvent = false;
      return null;
    }
  }

  // -------------------------
  // OPTIONAL: ADD GWP (currently not used)
  // -------------------------
  async function addGWP() {
    if (gwpLock) {
      console.log('[GWP] Add blocked by lock.');
      return;
    }
    gwpLock = true;

    console.log('[GWP] Adding GWP variant...');
    try {
      // [FIX] Same suppress-flag treatment as updateCart(), for consistency
      // if this ever gets wired up later.
      suppressNextEvent = true;
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: GWP_VARIANT_ID, quantity: 1 })
      });
      const data = await res.json();
      console.log('[GWP] GWP added:', data);
    } catch (err) {
      console.error('[GWP] Error adding GWP:', err);
      suppressNextEvent = false;
    } finally {
      setTimeout(() => (gwpLock = false), 500); // Reset lock
    }
  }

  // -------------------------
  // ENFORCE GWP RULES
  // -------------------------
  async function enforceGwpRules() {
    // [ISSUE] This function had NO reentrancy guard at all — gwpLock only
    // ever protected addGWP(), which isn't even called anywhere. Multiple
    // events firing close together (or the event-echo loop above) could
    // run enforceGwpRules concurrently, each one issuing its own network
    // calls.
    // [FIX] Wrap the whole function in the same lock pattern addGWP used.
    // --- BEFORE ---
    // async function enforceGwpRules() {
    //   const cart = await getCart();
    // --- AFTER ---
    if (gwpLock) {
      console.log('[GWP] Enforcement blocked by lock — a run is already in progress.');
      return;
    }
    gwpLock = true;

    try {
      const cart = await getCart();
      if (!cart) return;

      const total = cart.total_price / 100; // Convert cents → dollars

      // [ISSUE] i.variant_id (Number) === GWP_VARIANT_ID (String, before the
      // fix above) never matched, so gwpItems was always empty.
      // [FIX] Number() on both sides — resolved above by coercing
      // GWP_VARIANT_ID at declaration, plus explicit coercion here for
      // clarity/safety.
      // --- BEFORE ---
      // const gwpItems = cart.items.filter(i => i.variant_id === GWP_VARIANT_ID);
      // --- AFTER ---
      const gwpItems = cart.items.filter(i => Number(i.variant_id) === GWP_VARIANT_ID);

      console.log('[GWP] Cart total:', total, 'GWP items found:', gwpItems, 'Mode:', GWP_MODE);

      // -------------------------
      // Discount mode: never auto-remove. The gift stays visible in the
      // cart (with its own remove button) even if disqualified.
      // -------------------------
      if (GWP_MODE === 'discount') {
        console.log('[GWP] Discount mode — skipping auto-removal.');
        return;
      }

      // -------------------------
      // 1. Remove GWP if threshold NOT met — only if it's actually present
      // -------------------------
      if (total < THRESHOLD && gwpItems.length > 0) {
        console.log('[GWP] Threshold not met. Removing GWP item(s)...');
        const updates = {};
        gwpItems.forEach(i => updates[i.variant_id] = 0);
        await updateCart(updates);
        return;
      }

      // -------------------------
      // 2. Threshold met — GWP stays in cart
      // -------------------------
      if (total >= THRESHOLD) {
        console.log('[GWP] Threshold met. GWP remains in cart.');
        return;
      }

      console.log('[GWP] Enforcement complete. No changes needed.');
    } finally {
      // [FIX] Release the lock added above, same 500ms cooldown pattern as addGWP.
      setTimeout(() => (gwpLock = false), 500);
    }
  }

  // [FIX] New wrapper used only for the two events that our own updateCart()
  // call could plausibly re-trigger. Checks/consumes suppressNextEvent
  // before deciding whether to re-run enforcement — this is what actually
  // breaks the loop, rather than just relying on the lock to catch it in time.
  function handleCartEvent() {
    if (suppressNextEvent) {
      console.log('[GWP] Ignoring cart event triggered by our own update.');
      suppressNextEvent = false;
      return;
    }
    enforceGwpRules();
  }

  // -------------------------
  // INITIAL RUN
  // -------------------------
  enforceGwpRules();

  // -------------------------
  // DEFENSIVE EVENT LISTENERS
  // -------------------------
  // Handle back/forward browser cache — not something our own writes cause,
  // so this stays bound directly to enforceGwpRules (no suppress check needed).
  window.addEventListener("pageshow", enforceGwpRules);

  // [ISSUE] Both of these were bound directly to enforceGwpRules, with no
  // way to distinguish a real customer-driven cart change from the echo of
  // our own updateCart() write — the root cause of the 429 loop.
  // [FIX] Bind to handleCartEvent instead, which filters out self-triggered echoes.
  // --- BEFORE ---
  // document.addEventListener("ajaxCart:updated", enforceGwpRules);
  // document.addEventListener("cart:refresh", enforceGwpRules);
  // --- AFTER ---
  document.addEventListener("ajaxCart:updated", handleCartEvent);
  document.addEventListener("cart:refresh", handleCartEvent);
});
